/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { formatDate } from "utils";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { DetailedInventoryLedgerService } from "services/detailed-inventory-ledger";

const renderData = (items, setDataTable) => {
  return (items || []).map((item) => {
    return {
      id: item._id,
      accountNumber: item.accountNumber || "N/A",
      itemName: item.itemName || "N/A",
      warehouseName: item.warehouseName || "N/A",
      year: item.year || "N/A",
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Tên vật tư", accessor: "itemName", width: "25%" },
    { Header: "Tài khoản", accessor: "accountNumber", width: "15%" },
    { Header: "Kho", accessor: "warehouseName", width: "20%" },
    { Header: "Năm", accessor: "year", width: "15%" },
    { Header: "Ngày tạo", accessor: "createdAt", width: "15%" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function DetailedInventoryLedger() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await DetailedInventoryLedgerService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items = [], checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm !== undefined ? !createPerm : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items, setDataTable),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ chi tiết vật tư:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default DetailedInventoryLedger;
